// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DispositiveProvisionsPossibleRecipients_PrincipalFragment = { __typename?: 'Principal', id: string, individual?: { __typename?: 'ClientProfile', id: string } | null };

export type DispositiveProvisionsPossibleRecipients_EntityFragment = { __typename?: 'Entity', id: string, stage: Types.EntityStage, kind: Types.EntityKind, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'CLTTrust', id: string, gstStatus?: Types.EntityGstStatus | null, inEstateStatus: Types.EntityInEstateStatus, displayName: string } | { __typename?: 'CRTTrust', id: string, gstStatus?: Types.EntityGstStatus | null, inEstateStatus: Types.EntityInEstateStatus, displayName: string } | { __typename?: 'CustodialPersonalAccount', id: string, gstStatus?: Types.EntityGstStatus | null, inEstateStatus: Types.EntityInEstateStatus, displayName: string } | { __typename?: 'DonorAdvisedFund', id: string, gstStatus?: Types.EntityGstStatus | null, inEstateStatus: Types.EntityInEstateStatus, displayName: string } | { __typename?: 'GPBusinessEntity', id: string, displayName: string } | { __typename?: 'GRATTrust', id: string, gstStatus?: Types.EntityGstStatus | null, inEstateStatus: Types.EntityInEstateStatus, displayName: string } | { __typename?: 'ILITTrust', id: string, gstStatus?: Types.EntityGstStatus | null, inEstateStatus: Types.EntityInEstateStatus, displayName: string } | { __typename?: 'IndividualPersonalAccount', inEstateStatus: Types.EntityInEstateStatus, id: string, displayName: string, owner?: (
      { __typename?: 'Principal' }
      & DispositiveProvisionsPossibleRecipients_PrincipalFragment
    ) | null } | { __typename?: 'InsurancePersonalAccount', id: string, gstStatus?: Types.EntityGstStatus | null, inEstateStatus: Types.EntityInEstateStatus, displayName: string } | { __typename?: 'IrrevocableTrust', id: string, gstStatus?: Types.EntityGstStatus | null, inEstateStatus: Types.EntityInEstateStatus, displayName: string } | { __typename?: 'JointPersonalAccount', inEstateStatus: Types.EntityInEstateStatus, id: string, displayName: string, owners?: Array<(
      { __typename?: 'Principal' }
      & DispositiveProvisionsPossibleRecipients_PrincipalFragment
    )> | null } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string } | { __typename?: 'LPBusinessEntity', id: string, displayName: string } | { __typename?: 'PrivateFoundation', id: string, gstStatus?: Types.EntityGstStatus | null, inEstateStatus: Types.EntityInEstateStatus, displayName: string } | { __typename?: 'QPRTTrust', id: string, gstStatus?: Types.EntityGstStatus | null, inEstateStatus: Types.EntityInEstateStatus, displayName: string } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, gstStatus?: Types.EntityGstStatus | null, inEstateStatus: Types.EntityInEstateStatus, displayName: string } | { __typename?: 'RetirementPersonalAccount', inEstateStatus: Types.EntityInEstateStatus, id: string, displayName: string, owner?: (
      { __typename?: 'Principal' }
      & DispositiveProvisionsPossibleRecipients_PrincipalFragment
    ) | null } | { __typename?: 'RevocableTrust', inEstateStatus: Types.EntityInEstateStatus, id: string, displayName: string, grantors?: Array<(
      { __typename?: 'Principal' }
      & DispositiveProvisionsPossibleRecipients_PrincipalFragment
    )> | null } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'SLATTrust', id: string, gstStatus?: Types.EntityGstStatus | null, inEstateStatus: Types.EntityInEstateStatus, displayName: string } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string } };

export type DispositiveProvisionsPossibleRecipients_ClientProfileFragment = { __typename?: 'ClientProfile', id: string, displayName: string, displayGivenName: string, legalName: string, relationships?: Array<{ __typename?: 'ClientProfileRelationship', id: string, type: Types.ClientProfileRelationshipType, toClientProfile: { __typename?: 'ClientProfile', id: string } }> | null };

export type DispositiveProvisionsPossibleRecipients_ClientOrganizationFragment = { __typename?: 'ClientOrganization', id: string, name: string, kind?: Types.ClientOrganizationKind | null };

export type DispositiveProvisionsPossibleRecipients_TestamentaryEntityFragment = { __typename?: 'TestamentaryEntity', id: string, displayName: string, kind: Types.TestamentaryEntityKind, inEstateStatus?: Types.EntityInEstateStatus | null, survivingSpouseStateInEstateStatus?: Types.EntityInEstateStatus | null, accountOwner?: { __typename?: 'ClientProfile', id: string } | null, createdFromEntities: { __typename?: 'EntityConnection', edges?: Array<{ __typename?: 'EntityEdge', node?: { __typename?: 'Entity', id: string, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'CLTTrust', id: string, displayName: string } | { __typename?: 'CRTTrust', id: string, displayName: string } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string } | { __typename?: 'GPBusinessEntity', id: string, displayName: string } | { __typename?: 'GRATTrust', id: string, displayName: string } | { __typename?: 'ILITTrust', id: string, displayName: string } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string } | { __typename?: 'IrrevocableTrust', id: string, displayName: string } | { __typename?: 'JointPersonalAccount', id: string, displayName: string } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string } | { __typename?: 'LPBusinessEntity', id: string, displayName: string } | { __typename?: 'PrivateFoundation', id: string, displayName: string } | { __typename?: 'QPRTTrust', id: string, displayName: string } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string } | { __typename?: 'RevocableTrust', id: string, displayName: string } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'SLATTrust', id: string, displayName: string } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string } } | null } | null> | null } };

export type DispositiveProvisionsPossibleRecipients_HouseholdFragment = { __typename?: 'Household', id: string, clientProfiles?: Array<(
    { __typename?: 'ClientProfile' }
    & DispositiveProvisionsPossibleRecipients_ClientProfileFragment
  )> | null, clientOrganizations?: Array<(
    { __typename?: 'ClientOrganization' }
    & DispositiveProvisionsPossibleRecipients_ClientOrganizationFragment
  )> | null, entities: { __typename?: 'EntityConnection', edges?: Array<{ __typename?: 'EntityEdge', node?: (
        { __typename?: 'Entity' }
        & DispositiveProvisionsPossibleRecipients_EntityFragment
      ) | null } | null> | null }, testamentaryEntities?: { __typename?: 'TestamentaryEntityConnection', edges?: Array<{ __typename?: 'TestamentaryEntityEdge', node?: (
        { __typename?: 'TestamentaryEntity' }
        & DispositiveProvisionsPossibleRecipients_TestamentaryEntityFragment
      ) | null } | null> | null } };

export type DispositiveProvisionsPossibleRecipientsQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.HouseholdWhereInput>;
  hasDeadGrantors: Types.Scalars['Boolean']['input'];
}>;


export type DispositiveProvisionsPossibleRecipientsQuery = { __typename?: 'Query', households: { __typename?: 'HouseholdConnection', edges?: Array<{ __typename?: 'HouseholdEdge', node?: (
        { __typename?: 'Household' }
        & DispositiveProvisionsPossibleRecipients_HouseholdFragment
      ) | null } | null> | null } };

export const Operations = {
  Query: {
    DispositiveProvisionsPossibleRecipients: 'DispositiveProvisionsPossibleRecipients' as const
  },
  Fragment: {
    DispositiveProvisionsPossibleRecipients_Principal: 'DispositiveProvisionsPossibleRecipients_Principal' as const,
    DispositiveProvisionsPossibleRecipients_Entity: 'DispositiveProvisionsPossibleRecipients_Entity' as const,
    DispositiveProvisionsPossibleRecipients_ClientProfile: 'DispositiveProvisionsPossibleRecipients_ClientProfile' as const,
    DispositiveProvisionsPossibleRecipients_ClientOrganization: 'DispositiveProvisionsPossibleRecipients_ClientOrganization' as const,
    DispositiveProvisionsPossibleRecipients_TestamentaryEntity: 'DispositiveProvisionsPossibleRecipients_TestamentaryEntity' as const,
    DispositiveProvisionsPossibleRecipients_Household: 'DispositiveProvisionsPossibleRecipients_Household' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const DispositiveProvisionsPossibleRecipients_ClientProfileFragmentDoc = gql`
    fragment DispositiveProvisionsPossibleRecipients_ClientProfile on ClientProfile {
  id
  displayName
  displayGivenName
  legalName
  relationships {
    id
    type
    toClientProfile {
      id
    }
  }
}
    `;
export const DispositiveProvisionsPossibleRecipients_ClientOrganizationFragmentDoc = gql`
    fragment DispositiveProvisionsPossibleRecipients_ClientOrganization on ClientOrganization {
  id
  name
  kind
}
    `;
export const DispositiveProvisionsPossibleRecipients_PrincipalFragmentDoc = gql`
    fragment DispositiveProvisionsPossibleRecipients_Principal on Principal {
  id
  individual {
    id
  }
}
    `;
export const DispositiveProvisionsPossibleRecipients_EntityFragmentDoc = gql`
    fragment DispositiveProvisionsPossibleRecipients_Entity on Entity {
  id
  stage
  kind
  subtype {
    id
    displayName
    ... on RevocableTrust {
      grantors {
        ...DispositiveProvisionsPossibleRecipients_Principal
      }
      inEstateStatus
    }
    ... on JointPersonalAccount {
      owners {
        ...DispositiveProvisionsPossibleRecipients_Principal
      }
      inEstateStatus
    }
    ... on RetirementPersonalAccount {
      owner {
        ...DispositiveProvisionsPossibleRecipients_Principal
      }
      inEstateStatus
    }
    ... on IndividualPersonalAccount {
      owner {
        ...DispositiveProvisionsPossibleRecipients_Principal
      }
      inEstateStatus
    }
    ... on GRATTrust {
      id
      gstStatus
      inEstateStatus
    }
    ... on ILITTrust {
      id
      gstStatus
      inEstateStatus
    }
    ... on SLATTrust {
      id
      gstStatus
      inEstateStatus
    }
    ... on IrrevocableTrust {
      id
      gstStatus
      inEstateStatus
    }
    ... on QPRTTrust {
      id
      gstStatus
      inEstateStatus
    }
    ... on CustodialPersonalAccount {
      id
      gstStatus
      inEstateStatus
    }
    ... on QualifiedTuitionPersonalAccount {
      id
      gstStatus
      inEstateStatus
    }
    ... on CRTTrust {
      id
      gstStatus
      inEstateStatus
    }
    ... on CLTTrust {
      id
      gstStatus
      inEstateStatus
    }
    ... on DonorAdvisedFund {
      id
      gstStatus
      inEstateStatus
    }
    ... on PrivateFoundation {
      id
      gstStatus
      inEstateStatus
    }
    ... on InsurancePersonalAccount {
      id
      gstStatus
      inEstateStatus
    }
  }
}
    ${DispositiveProvisionsPossibleRecipients_PrincipalFragmentDoc}`;
export const DispositiveProvisionsPossibleRecipients_TestamentaryEntityFragmentDoc = gql`
    fragment DispositiveProvisionsPossibleRecipients_TestamentaryEntity on TestamentaryEntity {
  id
  displayName
  kind
  accountOwner {
    id
  }
  inEstateStatus
  survivingSpouseStateInEstateStatus
  inEstateStatus
  createdFromEntities {
    edges {
      node {
        id
        subtype {
          id
          displayName
        }
      }
    }
  }
}
    `;
export const DispositiveProvisionsPossibleRecipients_HouseholdFragmentDoc = gql`
    fragment DispositiveProvisionsPossibleRecipients_Household on Household {
  id
  clientProfiles {
    ...DispositiveProvisionsPossibleRecipients_ClientProfile
  }
  clientOrganizations {
    ...DispositiveProvisionsPossibleRecipients_ClientOrganization
  }
  entities {
    edges {
      node {
        ...DispositiveProvisionsPossibleRecipients_Entity
      }
    }
  }
  testamentaryEntities @include(if: $hasDeadGrantors) {
    edges {
      node {
        ...DispositiveProvisionsPossibleRecipients_TestamentaryEntity
      }
    }
  }
}
    ${DispositiveProvisionsPossibleRecipients_ClientProfileFragmentDoc}
${DispositiveProvisionsPossibleRecipients_ClientOrganizationFragmentDoc}
${DispositiveProvisionsPossibleRecipients_EntityFragmentDoc}
${DispositiveProvisionsPossibleRecipients_TestamentaryEntityFragmentDoc}`;
export const DispositiveProvisionsPossibleRecipientsDocument = gql`
    query DispositiveProvisionsPossibleRecipients($where: HouseholdWhereInput, $hasDeadGrantors: Boolean!) {
  households(where: $where) {
    edges {
      node {
        ...DispositiveProvisionsPossibleRecipients_Household
      }
    }
  }
}
    ${DispositiveProvisionsPossibleRecipients_HouseholdFragmentDoc}`;

/**
 * __useDispositiveProvisionsPossibleRecipientsQuery__
 *
 * To run a query within a React component, call `useDispositiveProvisionsPossibleRecipientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDispositiveProvisionsPossibleRecipientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDispositiveProvisionsPossibleRecipientsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      hasDeadGrantors: // value for 'hasDeadGrantors'
 *   },
 * });
 */
export function useDispositiveProvisionsPossibleRecipientsQuery(baseOptions: Apollo.QueryHookOptions<DispositiveProvisionsPossibleRecipientsQuery, DispositiveProvisionsPossibleRecipientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DispositiveProvisionsPossibleRecipientsQuery, DispositiveProvisionsPossibleRecipientsQueryVariables>(DispositiveProvisionsPossibleRecipientsDocument, withFetchPolicyContext(options));
      }
export function useDispositiveProvisionsPossibleRecipientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DispositiveProvisionsPossibleRecipientsQuery, DispositiveProvisionsPossibleRecipientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DispositiveProvisionsPossibleRecipientsQuery, DispositiveProvisionsPossibleRecipientsQueryVariables>(DispositiveProvisionsPossibleRecipientsDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useDispositiveProvisionsPossibleRecipientsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DispositiveProvisionsPossibleRecipientsQuery, DispositiveProvisionsPossibleRecipientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DispositiveProvisionsPossibleRecipientsQuery, DispositiveProvisionsPossibleRecipientsQueryVariables>(DispositiveProvisionsPossibleRecipientsDocument, withFetchPolicyContext(options));
        }
export type DispositiveProvisionsPossibleRecipientsQueryHookResult = ReturnType<typeof useDispositiveProvisionsPossibleRecipientsQuery>;
export type DispositiveProvisionsPossibleRecipientsLazyQueryHookResult = ReturnType<typeof useDispositiveProvisionsPossibleRecipientsLazyQuery>;
export type DispositiveProvisionsPossibleRecipientsSuspenseQueryHookResult = ReturnType<typeof useDispositiveProvisionsPossibleRecipientsSuspenseQuery>;
export type DispositiveProvisionsPossibleRecipientsQueryResult = Apollo.QueryResult<DispositiveProvisionsPossibleRecipientsQuery, DispositiveProvisionsPossibleRecipientsQueryVariables>;